export default class UserLocationStatus {
	constructor(public readonly id: string, public readonly value: string, public readonly label: string) {}

	static getStatuses(): UserLocationStatus[] {
		return [
			new UserLocationStatus(UserLocationStatusEnum.Stationary, UserLocationStatusEnum.Stationary, "Stationary"),
			new UserLocationStatus(UserLocationStatusEnum.Moving, UserLocationStatusEnum.Moving, "Moving"),
		]
	}

	static fromString(value: string) {
		return UserLocationStatus.getStatuses().filter(s => s.value == value)[0];
	}
}

export enum UserLocationStatusEnum {
	Stationary = "STATIONARY",
	Moving = "MOVING"
}
